import React, { memo, useContext } from 'react';
import {
  IconStockIncoming,
  IconStockInStock,
  IconStockOutOfStock,
  IconStockUnknown,
} from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import * as S from './styles';
import { StockStatusStates } from './types';
import { TooltipPlacement } from '../tooltip-new';

type StockStatusProps = {
  className?: string;
  size?: number;
  status?: StockStatusStates | null;
  statusText?: string;
  tooltip?: string | true;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

type StockStatusTranslationKey =
  | 'stock-status.pre_order'
  | 'stock-status.incoming'
  | 'stock-status.in_stock'
  | 'stock-status.not_in_stock'
  | 'stock-status.unknown';

export const StockStatus = memo((props: StockStatusProps) => {
  const {
    className,
    size,
    status,
    statusText,
    tooltip,
    tooltipPlacement = 'left',
  } = props;
  const { t } = useContext(AppContext);

  const renderIconComponent = () => {
    switch (status) {
      case 'in_stock_preorder':
      case 'incoming':
        return <IconStockIncoming size={size} color="yellove700" />;
      case 'in_stock':
        return <IconStockInStock size={size} color="positive500" />;
      case 'not_in_stock':
        return <IconStockOutOfStock size={size} color="redio700" />;
      default:
        return <IconStockUnknown size={size} color="base400" />;
    }
  };

  const getStatusText = (): string => {
    if (status === 'incoming' && statusText) {
      return statusText.replace(/-/g, '‑'); // Replace hyphen with hard hyphen to prevent row break in date (Eg in 2019-08-10).
    }

    return t(
      'product',
      `stock-status.${status || 'unknown'}` as StockStatusTranslationKey
    );
  };

  return (
    <S.Tooltip
      placement={tooltipPlacement as TooltipPlacement}
      title={tooltip === true ? getStatusText() : tooltip}
      className={className}
      renderOnMouseOver
    >
      <S.IconAndText>{renderIconComponent()}</S.IconAndText>
    </S.Tooltip>
  );
});

export type StockStatusType = StockStatusStates;
